import { makeStyles, Grid } from '@paintscout/ui'
import type { MuiTheme as Theme } from '@paintscout/ui'
import { KeypadInputField, useClientOptions } from '@paintscout/ui-business'
import React, { useContext, useState } from 'react'
import type { QuoteDocument } from 'paintscout'
import { QuoteContext } from '@paintscout/react-quote'
import ErrorIcon from '@material-ui/icons/Error'
import type { QuoteDetails } from '@paintscout/util/builder'
import { getCompanyOptions, getDetails, setDetails } from '@paintscout/util/builder'
import DetailsItem from './DetailsItem'

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  alignRightInput: {
    textAlign: 'right'
  },
  adornmentSelect: {
    paddingRight: theme.spacing(1)
  }
}))

interface ServiceFeeItemProps {
  onChange: (args: { quote: QuoteDocument }) => void
  disabled: boolean
  expanded: boolean
  onExpand: (expanded: boolean) => void
}

export function ServiceFeeItem(props: ServiceFeeItemProps) {
  const { onChange, expanded, onExpand } = props
  const { quote } = useContext(QuoteContext)
  const { options } = useClientOptions()
  const companyOptions = getCompanyOptions({ options })
  const [details, setStateDetails] = useState(getDetails({ quote, options }))

  const classes = useStyles({})
  const updateDetails = (updatedDetails: QuoteDetails) => {
    setStateDetails(updatedDetails)
    onChange({ quote: setDetails({ quote, options, details: updatedDetails }) })
  }

  return (
    <DetailsItem
      label={'Service Fee'}
      value={quote.totals.service_fee_visible}
      expandIcon={details.totalAdjustment.rate ? <ErrorIcon /> : null}
      expanded={expanded}
      onExpand={onExpand}
      detailsComponent={
        <Grid container direction="row" justifyContent="flex-end" spacing={2}>
          <Grid item={true} xs={12}>
            <Grid item>
              <KeypadInputField
                value={details.serviceFees.visibleValue !== undefined ? details.serviceFees.visibleValue : ''}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  updateVisibleServiceFee(event.target.value)
                }}
                disabled={!companyOptions.serviceFees.allowCustom}
                fullWidth={true}
                margin="dense"
                format={'price'}
                label={`Visible Service Fee (%)`}
                classes={{ inputInput: classes.alignRightInput }}
                style={{ width: '100%' }}
              />
            </Grid>
          </Grid>
        </Grid>
      }
    />
  )
  function updateVisibleServiceFee(value: string) {
    updateDetails({
      ...details,
      serviceFees: {
        ...details?.serviceFees,
        visibleValue: Number(value)
      }
    })
  }
}
